import React from 'react';
import PropTypes from 'prop-types';
// Assets
import BrushCaret from '../../assets/brush/brush-caret.png';
// Utils
import { propLink } from '../link-handler';
import { NamedIconProps } from '../../prop-types';
import { replaceLineBreakShortCode } from '../../utils/replace-shortcode-br';
import CTA from '../cta';
// Styles
import {
  BrushElement,
  ElementWrapper,
  FlexContainer,
  ImageContainer,
  LeftColumn,
  RightColumn,
  StyledContainer,
  StyledCTA,
  Title,
  Wrapper,
} from './styles';

const CampaignHero = ({ content }) => {
  const { title, image, cta, removeMarginBottom, altLayout } = content;

  return (
    <Wrapper $removeMarginBottom={removeMarginBottom}>
      <StyledContainer>
        <FlexContainer $altLayout={altLayout}>
          <LeftColumn $altLayout={altLayout}>
            <ImageContainer $image={image} />
          </LeftColumn>
          <RightColumn $altLayout={altLayout}>
            <Title>{replaceLineBreakShortCode(title)}</Title>
            {!altLayout ? (
              <ElementWrapper>
                <BrushElement src={BrushCaret} alt="" />
              </ElementWrapper>
            ) : null}
            {altLayout && cta ? (
              <ElementWrapper>
                <CTA
                  bg="primary"
                  iconPlacement="right"
                  icon={cta.icon}
                  link={cta.link}
                >
                  {cta.buttonText}
                </CTA>
              </ElementWrapper>
            ) : null}
          </RightColumn>
        </FlexContainer>
      </StyledContainer>
    </Wrapper>
  );
};

CampaignHero.defaultProps = {
  content: {
    removeMarginBottom: true,
  },
};

CampaignHero.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    image: PropTypes.object,
    cta: PropTypes.shape({
      buttonText: PropTypes.string.isRequired,
      link: propLink.isRequired,
      icon: NamedIconProps,
    }),
    altLayout: PropTypes.bool,
    removeMarginBottom: PropTypes.bool,
  }),
};

export default CampaignHero;

export const CampaignHeroAssembly = ({ contentfulData }) => (
  <CampaignHero
    content={{
      title: contentfulData.title,
      image: contentfulData.image,
      cta: contentfulData.cta,
      altLayout: contentfulData.altLayout,
      removeMarginBottom: contentfulData.removeMarginBottom,
    }}
  />
);

CampaignHeroAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
